import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface ShipmentNotification {
  id: string;
  message: string;
  timestamp: Date;
  shipmentId: string;
  userId: string;
  userName: string;
  companyId: string;
}

export const useNotificationStore = defineStore('notifications', () => {
  const notifications = ref<ShipmentNotification[]>([]);

  function addNotification(notification: ShipmentNotification) {
    notifications.value.unshift(notification);
    // Mantener solo las últimas 10 notificaciones
    if (notifications.value.length > 10) {
      notifications.value.pop();
    }
  }

  function clearNotifications() {
    notifications.value = [];
  }

  return {
    notifications,
    addNotification,
    clearNotifications,
  };
});
